import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';

export default function BillingSuccess() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    // The webhook is the source of truth and may land a moment after redirect,
    // so poll a few times before giving up.
    let attempts = 0;
    const check = () => {
      api
        .billingStatus()
        .then((data) => {
          if (!active) return;
          setStatus(data);
          if (data?.active || attempts >= 4) {
            setLoading(false);
          } else {
            attempts += 1;
            setTimeout(check, 1500);
          }
        })
        .catch(() => {
          if (!active) return;
          setLoading(false);
        });
    };
    check();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
        <svg className="text-primary" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      <h1 className="mt-6 text-2xl font-bold text-foreground">
        {loading ? 'Confirming your subscription…' : status?.active ? 'Welcome to Pro!' : 'Payment received'}
      </h1>
      <p className="mt-2 text-sm text-muted-foreground">
        {loading
          ? 'This can take a few seconds while we confirm your payment.'
          : status?.active
            ? 'Your Cosmic Learning Pro subscription is now active. Enjoy full access!'
            : 'Thanks! Your subscription will activate shortly. Refresh in a moment if it hasn’t updated.'}
      </p>
      <Link
        to="/dashboard"
        className="mt-8 inline-flex min-h-[2.75rem] items-center justify-center rounded-xl bg-gradient-to-r from-primary to-accent px-8 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-opacity hover:opacity-95"
      >
        Go to Dashboard
      </Link>
    </div>
  );
}
